export default "__VITE_ASSET__DaFmx5Bj__"